module.exports = __webpack_public_path__ + "img/symbol-fx-center.c85862a3.png";